import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Message, SpinnerService } from 'shared-components';

@Component({
    selector: 'app-cajas-pallet-list',
    templateUrl: './cajas-pallet-list.component.html'
})
export class CajasPalletListComponent implements OnInit {

    public confeccionesPallet = [];

    public pestanaActiva;
    public dropdownSection: number;

    @Input() desgloseConfeccionesPallet;

    constructor(private readonly _translate: TranslateService) {}

    ngOnInit() {
        this.getCajas();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    private getCajas() {
        for (let cajaConfeccion of this.desgloseConfeccionesPallet) {
            this.confeccionesPallet.push(cajaConfeccion);
        }
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva = 1;
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showEnvases() {
        this.pestanaActiva = 1;
    }
}
